module.exports = __webpack_public_path__ + "img/nine1.88512e48.png";